import { Link, useNavigate } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

/**
 * The back affordance every detail page shares: an explicit ← Back button
 * (browser history when there is any, the dashboard otherwise) beside the
 * breadcrumb trail. Deep links land here without history, so the button can
 * never dead-end.
 */
export function BackBar({ crumbs }: { crumbs: Crumb[] }) {
  const navigate = useNavigate();
  const goBack = () => {
    // react-router stamps its history index on window.history.state — 0
    // means this entry is the first (a deep link / new tab).
    const idx = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (idx > 0) navigate(-1);
    else navigate("/tracking/health");
  };
  return (
    <div className="flex items-center gap-2 text-sm text-gray-500 flex-wrap">
      <button
        onClick={goBack}
        className="inline-flex items-center gap-1 px-2 py-1 -ml-2 rounded font-medium text-content-secondary hover:bg-gray-100 hover:text-content-primary"
      >
        ← Back
      </button>
      <span className="text-gray-300">|</span>
      <nav className="flex items-center gap-1.5 flex-wrap">
        {crumbs.map((crumb, i) => (
          <span key={i} className="flex items-center gap-1.5">
            {i > 0 && <span className="text-gray-300">/</span>}
            {crumb.to ? (
              <Link to={crumb.to} className="hover:text-content-primary">
                {crumb.label}
              </Link>
            ) : (
              <span className="text-content-secondary">{crumb.label}</span>
            )}
          </span>
        ))}
      </nav>
    </div>
  );
}
